import React from "react";
import "./loading.css";

export type LoadingType = "dot" | "spin" | "pulse" | "stable";

export interface ILoadingPropDTO {
  type?: LoadingType;
  size?: "sm" | "md" | "lg";
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Loading: React.FC<ILoadingPropDTO> = ({
  type = "spin",
  size = "md",
  color = "#6c757d",
  className = "",
  style = {},
  ...rest
}) => {
  const sizeClasses = {
    sm: "loading-sm",
    md: "loading-md",
    lg: "loading-lg",
  };

  return (
    <div
      className={`loading loading-${type} ${sizeClasses[size]} ${className}`}
      style={
        {
          "--loading-color": color,
          ...style,
        } as React.CSSProperties
      }
      {...rest}
    >
      <div className="loading-spinner"></div>
    </div>
  );
};

export { Loading as default };
